package antd.tabs

import antd.datepicker.RangePickerProps
import kotlinext.js.jsObject
import react.ComponentType
import react.RBuilder
import react.RHandler

fun RBuilder.tabs(handler: RHandler<TabsProps>) = child(TabsComponent::class, handler)
fun RBuilder.tabPane(handler: RHandler<TabPaneProps>) = child(TabsComponent.TabPane as ComponentType<TabPaneProps>,jsObject{}, handler)
